type networkKindCopy = 'copy'
type networkKindWhatsapp = 'whatsapp'

type networkKind = networkKindCopy | networkKindWhatsapp

export type networkCopyType = {
  kind: networkKindCopy
  url: string
  title: string
  copiedText: string
}

export type networkWhatsappType = {
  kind: networkKindWhatsapp
  url: string
  title: string
  message: string
}

export type networkType = networkCopyType | networkWhatsappType
export type networksType = Array<networkType>

export const iconNameByKind: Required<Record<networkKind, string>> = {
  copy: 'i-heroicons-link-solid',
  whatsapp: 'i-ic-baseline-whatsapp',
}

type variant = 'buttons' | 'buttonsRow'

export interface propsInterface {
  networks: networksType
  variant?: variant
}
